// Lodging cart line. Framework-free so it is unit-testable without rendering
// the Type step.
import type { BookingItem } from '@/stores/bookingData';
import { mapItemToBookingItem } from '@/services/price';

type Venue = 'lasalle' | 'serre' | '';
type GetService = (id: string) => any;

/**
 * The `logement` line at `guests` people. The order row is always `logement`;
 * at La Serre it is priced with the `logement_serre` package and per-person fee.
 * Null when the catalog has no `logement` service.
 */
export function buildLogementBooking(getService: GetService, guests: number, venue: Venue): BookingItem | null {
  const logementService = getService('logement');
  if (!logementService) return null;

  const logementBooking = mapItemToBookingItem(logementService, guests);
  if (venue === 'serre') {
    const serreLogement = getService('logement_serre');
    if (serreLogement) {
      logementBooking.packagePrice = serreLogement.Prix;
      logementBooking.unitPrice = serreLogement['Prix par personne'] || logementBooking.unitPrice;
    }
  }
  return logementBooking;
}
